// Fachada de leituras de sessão/identidade — métodos do repo (ver core.ts).
import { sessionRepo } from './core';

export type {
  ProfileRow,
  WorkspaceRow,
  TimeRow,
  WorkspaceMemberRole,
  TeamMembershipRow,
  MemberWorkspaceRow,
} from '@modules/session';

export const getProfile               = sessionRepo.getProfile;
export const createBasicProfile       = sessionRepo.createBasicProfile;
export const markFirstAccessDone      = sessionRepo.markFirstAccessDone;
export const getWorkspaceMemberships  = sessionRepo.getWorkspaceMemberships;
export const getWorkspace             = sessionRepo.getWorkspace;
export const getWorkspaceMemberRole   = sessionRepo.getWorkspaceMemberRole;
export const getTeamMembership        = sessionRepo.getTeamMembership;
export const listTeamMemberIds        = sessionRepo.listTeamMemberIds;
export const listAllActiveWorkspaces  = sessionRepo.listAllActiveWorkspaces;
export const listMemberWorkspaces     = sessionRepo.listMemberWorkspaces;
